export interface DashboardChartColors {
    budget: string;
    forecast: string;
    actuals: string;
    pie: string[];
    sparklineActuals: string;
    sparklineForecast: string;
    sparklineVariance: string;
}

export const dashboardWidgetCardSx = {
    borderRadius: 2,
    p: 2.5,
    height: "100%",
    bgcolor: "background.paper",
    backgroundImage: "none",
};

export const formatGbp = (value: number): string => {
    return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);
};

export const formatCompactGbp = (value: number): string => {
    const formatter = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
        notation: "compact",
        maximumFractionDigits: 1,
    });

    return formatter
        .formatToParts(value)
        .map(part => part.type === "compact" ? part.value.toLowerCase() : part.value)
        .join("");
};

export const formatUnits = (value: number): string => {
    return new Intl.NumberFormat("en-GB", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);
};

export const formatSignedPercent = (value: number): string => {
    const prefix = value > 0 ? "+" : "";
    return `${prefix}${value.toFixed(1)}%`;
};

export const formatYtdAttainment = (
    ytdActuals: number,
    ytdBudget: number,
): { value: string; caption: string } => {
    if (ytdBudget === 0) {
        return {
            value: "n/a",
            caption: "No YTD budget",
        };
    }

    return {
        value: `${((ytdActuals / ytdBudget) * 100).toFixed(1)}%`,
        caption: `vs ${formatGbp(ytdBudget)} YTD budget`,
    };
};

export const getDashboardChartColors = (mode: "light" | "dark"): DashboardChartColors => {
    if (mode === "dark") {
        return {
            budget: "#94a3b8",
            forecast: "#38bdf8",
            actuals: "#2dd4bf",
            pie: ["#7dd3fc", "#38bdf8", "#2dd4bf", "#a78bfa", "#fb7185"],
            sparklineActuals: "#2dd4bf",
            sparklineForecast: "#38bdf8",
            sparklineVariance: "#a78bfa",
        };
    }

    return {
        budget: "#94a3b8",
        forecast: "#2568FF",
        actuals: "#14b8a6",
        pie: ["#64748b", "#2568FF", "#14b8a6", "#8b5cf6", "#f43f5e"],
        sparklineActuals: "#14b8a6",
        sparklineForecast: "#2568FF",
        sparklineVariance: "#8b5cf6",
    };
};

export const getSeriesColor = (label: string, colors: DashboardChartColors): string => {
    if (label === "Budget") {
        return colors.budget;
    }

    if (label === "Actuals") {
        return colors.actuals;
    }

    return colors.forecast;
};
